import { dotsState, DOT_CATALOG } from './ggPlayDots.js'
import { setGameField } from './ggGamesData.js'

// Live Dots panel + per-hole award UI. For each selected TAP dot (greenie,
// sandie, …) a row of player buttons awards/removes that dot on the current
// hole (stored at dots/{hole}/{pid}). Birdie/eagle auto-count from scores.
// Running per-player dots + zero-sum $ shown below. Renders only when Dots is on.
const money = (v) => (Math.round(v) === 0 ? '$0' : v > 0 ? `+$${Math.round(v)}` : `−$${Math.round(-v)}`)
const row = { display: 'flex', justifyContent: 'space-between', fontSize: 16, padding: '3px 0' }

export default function GDotsPanel({ gameId, game, hole }) {
  const d = game?.meta?.addons?.dots
  if (!d?.enabled) return null
  const st = dotsState(game)
  if (!st) return null
  const inPlay = d.dotsInPlay || []
  const tapTypes = DOT_CATALOG.filter((c) => !c.auto && inPlay.includes(c.key))
  const autoTypes = DOT_CATALOG.filter((c) => c.auto && inPlay.includes(c.key))
  const players = game.players || []
  const holeDots = game.dots?.[hole] || {}
  const has = (pid, key) => Array.isArray(holeDots[pid]) && holeDots[pid].includes(key)
  const toggle = (pid, key) => {
    const cur = Array.isArray(holeDots[pid]) ? holeDots[pid] : []
    const nextArr = cur.includes(key) ? cur.filter((k) => k !== key) : [...cur, key]
    setGameField(gameId, `dots/${hole}/${pid}`, nextArr.length ? nextArr : null)
  }
  const first = (nm) => nm.split(' ')[0]

  return (
    <div style={{ border: '1px solid #93C5FD', borderRadius: 12, padding: 12, marginTop: 12, background: '#EFF6FF' }}>
      <div className="flex items-center justify-between mb-1">
        <span className="font-bold text-sm">💠 Dots</span>
        <span className="text-[10px] text-gray-500">${st.dotValue}/dot · {st.total} total{autoTypes.length ? ` · auto: ${autoTypes.map((c) => c.label).join('/')}` : ''}</span>
      </div>
      {tapTypes.length > 0 ? (
        <div className="space-y-1.5 mb-2">
          {tapTypes.map((c) => (
            <div key={c.key} className="flex items-center gap-1.5 flex-wrap">
              <span className="text-xs font-semibold text-gray-600" style={{ width: 84 }}>{c.emoji} {c.label}</span>
              {players.map((p) => (
                <button key={p.id} type="button" onClick={() => toggle(p.id, c.key)} className="text-xs px-2 py-1 rounded"
                  style={{ border: `1px solid ${has(p.id, c.key) ? '#1D4ED8' : '#CBD5E1'}`, background: has(p.id, c.key) ? '#1D4ED8' : '#fff', color: has(p.id, c.key) ? '#fff' : '#374151', fontWeight: has(p.id, c.key) ? 700 : 500 }}>
                  {first(p.name)}
                </button>
              ))}
            </div>
          ))}
          <div className="text-[11px] text-gray-400">Tap a name to award {tapTypes.map((c) => c.label).join(' / ')} on hole {hole}.</div>
        </div>
      ) : (
        <div className="text-[11px] text-gray-400 mb-2">No tap-dots selected — birdies/eagles auto-count from scores.</div>
      )}
      <div>
        {st.rows.map((r) => (
          <div key={r.id} style={row}>
            <span>{r.name}</span>
            <span><b>{r.dots}</b> dot{r.dots === 1 ? '' : 's'}<b className="ml-3" style={{ color: r.net > 0 ? '#1B7A3E' : r.net < 0 ? '#B42318' : '#888' }}>{money(r.net)}</b></span>
          </div>
        ))}
      </div>
    </div>
  )
}
